import React, { useState } from "react";
import { useSelector } from "react-redux";
import CircularImageWithCaption from "../../utils/utils";
export default function DashProfile() {
  const { user } = useSelector((state) => state.user);

  return (
    <div className="container mx-auto mt-8 ml-8">
      <CircularImageWithCaption
        title={user.organization}
      ></CircularImageWithCaption>
    </div>
  );
}
